import { graphql } from '@/gql'

export const WebhooksQuery = graphql(/* GraphQL */ `
  query Webhooks($accounts: [ID!], $first: Int!, $page: Int!) {
    webhooks(accounts: $accounts, first: $first, page: $page) {
      data {
        ...WebhookFragment
      }
      paginatorInfo {
        ...PaginatorInfoFragment
      }
    }
  }
`)

export const WebhookEventLogsQuery = graphql(/* GraphQL */ `
  query WebhookEventLogs($accounts: [ID!], $first: Int!, $page: Int!) {
    webhookEventLogs(accounts: $accounts, first: $first, page: $page) {
      data {
        ...WebhookEventLogFragment
      }
      paginatorInfo {
        ...PaginatorInfoFragment
      }
    }
  }
`)
